const modalEventListener = (ref, closeModal, datepickerCond = false) => {
  const checkIfClickedOutside = (e) => {
    if (datepickerCond && isClickInsideDatepicker(e)) return;
    if (ref.current && !ref.current.contains(e.target)) closeModal();
  };

  document.body.style.overflow = "hidden";
  document.addEventListener("click", checkIfClickedOutside);
  return () => {
    document.body.style.overflow = "scroll";
    document.removeEventListener("click", checkIfClickedOutside);
  };
};

const modalEventListenerAllowScroll = (ref, closeModal, elementScroll) => {
  const checkIfClickedOutside = (e) => {
    if (ref.current && !ref.current.contains(e.target)) closeModal();
  };
  if (elementScroll) {
    document.body.style.overflow = "hidden";
    document.querySelector(elementScroll).style.overflow = "scroll";
  }
  document.addEventListener("click", checkIfClickedOutside);
  return () => {
    if (elementScroll) {
      document.body.style.overflow = "scroll";
    }
    document.removeEventListener("click", checkIfClickedOutside);
  };
};

const isClickInsideDatepicker = (e) => {
  return (
    e.target.closest(".datepicker") ||
    e.target.closest(".react-datepicker__navigation")
  );
};

const modalEventListenerAllowXScroll = (ref, closeModal) => {
  const checkIfClickedOutside = (e) => {
    if (ref.current && !ref.current.contains(e.target)) closeModal();
  };
  document.body.style.overflowY = "hidden";
  document.addEventListener("click", checkIfClickedOutside);
  return () => {
    document.body.style.overflowY = "scroll";
    document.removeEventListener("click", checkIfClickedOutside);
  };
};

export {
  modalEventListener,
  modalEventListenerAllowScroll,
  modalEventListenerAllowXScroll,
};
